import * as yup from "yup";
// import { patterns } from "../../components/InputField";

export const defaultVal = () => ({
  nombre: "",
  notas: "",
  taller: 'no',
});

export const validation = () =>
  yup.object({
    nombre: yup.string().required("Requerido"),
    taller: yup.string().required("Requerido"),
  });

export const obrasForm = () => [
  {
    props: {
      name: "nombre",
      label: "Nombre",
      type: "text",
      uppercase: true,
      autoFocus: true,
    },
    width: 10,
  },
  {
    props: {
      name: "taller",
      label: "Taller",
      select: true,
      options: [
        {label: 'No', value: 'no'},
        {label: 'Si', value: 'si'},
      ]
    },
    width: 2,
  },
  {
    props: {
      name: "notas",
      label: "Notas",
      type: "text",
      uppercase: true,
    },
    width: 12,
  },
];
